(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lxb-category-row"] && !Shopify.designMode) return;
  try {
    
    (function () {
      if (customElements.get('lxb-category-row')) return;

      class LxbCategoryRow extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-lxb-track]');
          if (!this.track || this.dataset.carousel !== 'true') return;

          // Archetype's own boot pattern — see sections/shoppable-hero.liquid:296-307.
          // theme.js is deferred and registers inside DOMready, so `theme` may not exist yet.
          if (window.theme && window.theme.Slideshow) {
            this.build();
          } else {
            this._onReady = () => this.build();
            document.addEventListener('page:loaded', this._onReady, { once: true });
          }
        }

        build() {
          if (this.flickity || !window.theme || !window.theme.Slideshow) return;

          var reduced = window.theme.a11y &&
            typeof window.theme.a11y.prefersReducedMotion === 'function' &&
            window.theme.a11y.prefersReducedMotion();

          // `fade` is intentionally omitted -> theme.Slideshow default fade:false -> a real
          // horizontal track. Slides-per-view comes from the cell CSS width, not from here.
          this.flickity = new window.theme.Slideshow(this.track, {
            cellAlign: 'left',
            groupCells: true,          // dots paginate by PAGE, matching the live site
            contain: true,
            wrapAround: false,
            pageDots: this.dataset.dots === 'true',
            prevNextButtons: this.dataset.arrows === 'true',
            adaptiveHeight: false,
            pauseAutoPlayOnHover: true,
            autoPlay: this.dataset.autoplay === 'true' && !reduced
              ? parseInt(this.dataset.autoplaySpeed, 10)
              : false
          });
        }

        disconnectedCallback() {
          if (this._onReady) document.removeEventListener('page:loaded', this._onReady);
          if (this.flickity && typeof this.flickity.destroy === 'function') {
            try { this.flickity.destroy(); } catch (e) { /* editor teardown races are harmless */ }
          }
          this.flickity = null;
        }
      }

      customElements.define('lxb-category-row', LxbCategoryRow);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lxb-collections-mega"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('lxb-collections-mega')) return;

  // The theme's desktop breakpoint: `small--hide` is max-width 768px, and the desktop nav
  // (ul.site-nav.small--hide) does not exist visually below it. The mobile drawer is untouched.
  var DESKTOP = window.matchMedia('(min-width: 769px)');
  // Editor support: one pristine copy (HTML string) per section, re-inserted if the header
  // re-renders and takes the attached panel with it.
  var registry = {};

  function handleize(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/['"’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  class LxbCollectionsMega extends HTMLElement {
    connectedCallback() {
      // Moving ourselves into the nav <li> fires connectedCallback again — ignore that one.
      if (this.host) return;
      var id = this.dataset.sectionId;
      // Editor only, and as an HTML STRING: a cloneNode() copy is a detached <img>, which
      // ignores loading="lazy" and fetches immediately — measured on the candidate as the hero
      // photo downloading on every phone page view (CDP initiator: this connectedCallback).
      if (window.Shopify && window.Shopify.designMode &&
          (!registry[id] || registry[id].home !== this.parentElement)) {
        registry[id] = { home: this.parentElement, html: this.outerHTML };
      }
      this._tryAttach = this.tryAttach.bind(this);
      if (DESKTOP.matches) {
        this.tryAttach();
      } else {
        DESKTOP.addEventListener('change', this._tryAttach);
      }
    }

    disconnectedCallback() {
      // A move (appendChild into the <li>) disconnects and reconnects in the same task, so only
      // tear down if we are still detached after it.
      var self = this;
      Promise.resolve().then(function () {
        if (!self.isConnected) self.teardown();
      });
    }

    findLink() {
      var want = handleize(this.dataset.menuItem);
      if (!want) return null;
      var links = document.querySelectorAll('#SiteHeader .site-nav.site-navigation > li.site-nav__item > a.site-nav__link');
      for (var i = 0; i < links.length; i++) {
        if (handleize(links[i].textContent) === want) return links[i];
      }
      return null;
    }

    tryAttach() {
      if (this.host || !DESKTOP.matches) return;
      var link = this.findLink();
      if (!link) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._tryAttach, { once: true });
        }
        return; // no childless item by that name: COLLECTIONS stays a plain link
      }
      DESKTOP.removeEventListener('change', this._tryAttach);
      var li = link.parentElement;
      var id = this.dataset.sectionId;
      var taken = false;
      li.querySelectorAll(':scope > lxb-collections-mega').forEach(function (n) {
        if (n.dataset.sectionId === id) n.remove(); // stale copy left by an editor re-render
        else taken = true;                          // another instance already owns this item
      });
      if (taken) return; // first instance wins — never stack two panels under one menu item
      this.host = li;
      this.link = link;
      li.classList.add('lxb-cmega-host');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', this.id);
      li.appendChild(this);
      this.bind();
    }

    bind() {
      var self = this;
      var li = this.host;
      this._h = {
        enter: function () { if (!self.escaped) self.open(); },
        leave: function () { self.escaped = false; if (!self.pinned) self.close(); },
        focusin: function () { if (!self.escaped) self.open(); },
        focusout: function (e) {
          if (!li.contains(e.relatedTarget)) {
            self.escaped = false;
            if (!self.pinned) self.close();
          }
        },
        key: function (e) {
          if (e.key === 'Escape' && self.isOpen) {
            // Consume it: theme.js binds a document-level Escape (PredictiveSearch.close ->
            // closeSearchDrawer) that calls document.activeElement.blur() on EVERY Escape,
            // which would throw focus to <body> right after we return it to the link. Measured
            // on the rendered candidate 2026-09-10. The search drawer cannot be open while
            // focus is inside this panel, so nothing of the vendor's is skipped.
            e.stopPropagation();
            // Focus the link BEFORE hiding: hiding a focused panel link first lets the browser
            // blur it with no relatedTarget, which would reset `escaped` and reopen on refocus.
            self.escaped = true;
            self.link.focus();
            self.close();
          }
        },
        bp: function () { if (!DESKTOP.matches) self.close(); }
      };
      li.addEventListener('mouseenter', this._h.enter);
      li.addEventListener('mouseleave', this._h.leave);
      li.addEventListener('focusin', this._h.focusin);
      li.addEventListener('focusout', this._h.focusout);
      li.addEventListener('keydown', this._h.key);
      DESKTOP.addEventListener('change', this._h.bp);
    }

    teardown() {
      DESKTOP.removeEventListener('change', this._tryAttach);
      if (!this.host || !this._h) return;
      var li = this.host;
      li.removeEventListener('mouseenter', this._h.enter);
      li.removeEventListener('mouseleave', this._h.leave);
      li.removeEventListener('focusin', this._h.focusin);
      li.removeEventListener('focusout', this._h.focusout);
      li.removeEventListener('keydown', this._h.key);
      DESKTOP.removeEventListener('change', this._h.bp);
      if (!li.querySelector(':scope > lxb-collections-mega')) {
        li.classList.remove('lxb-cmega-host');
        this.link.removeAttribute('aria-expanded');
        this.link.removeAttribute('aria-controls');
      }
      this._h = null;
    }

    open() {
      if (this.isOpen || !this.host) return;
      // One panel at a time: close any vendor mega/dropdown that is still open.
      document.querySelectorAll('#SiteHeader details.site-nav__details[open]').forEach(function (d) {
        d.removeAttribute('open');
        d.setAttribute('aria-expanded', 'false');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
      this.hidden = false;
      this.classList.add('is-open');
      this.isOpen = true;
      this.link.setAttribute('aria-expanded', 'true');
    }

    close() {
      if (!this.isOpen) return;
      this.hidden = true;
      this.classList.remove('is-open');
      this.isOpen = false;
      this.link.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('lxb-collections-mega', LxbCollectionsMega);

  if (window.Shopify && window.Shopify.designMode) {
    function mine(e) {
      var id = e.detail && e.detail.sectionId;
      return id ? document.querySelector('lxb-collections-mega[data-section-id="' + id + '"]') : null;
    }
    // Header re-rendered in the editor: its <li> and our attached panel are gone. Re-insert a
    // pristine copy into this section so it re-attaches to the new header markup.
    document.addEventListener('shopify:section:load', function () {
      Object.keys(registry).forEach(function (id) {
        var r = registry[id];
        if (!document.querySelector('lxb-collections-mega[data-section-id="' + id + '"]') && r.home.isConnected) {
          r.home.insertAdjacentHTML('beforeend', r.html); // parsed connected, so lazy still applies
        }
      });
    });
    // Selecting this section or one of its blocks in the editor pins the panel open.
    ['shopify:section:select', 'shopify:block:select'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var el = mine(e);
        if (el && el.host) { el.pinned = true; el.open(); }
      });
    });
    ['shopify:section:deselect', 'shopify:block:deselect'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var el = mine(e);
        if (el) { el.pinned = false; el.close(); }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lxb-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('lxb-lookbook-carousel')) return;

  class LxbLookbookCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lxb-track]');
      if (!this.track || this.dataset.carousel !== 'true') return;

      // Archetype's own boot pattern — see sections/shoppable-hero.liquid:296-307.
      // theme.js is deferred and registers inside DOMready, so `theme` may not exist yet.
      if (window.theme && window.theme.Slideshow) {
        this.build();
      } else {
        this._onReady = () => this.build();
        document.addEventListener('page:loaded', this._onReady, { once: true });
      }
    }

    build() {
      if (this.flickity || !window.theme || !window.theme.Slideshow) return;

      var reduced = window.theme.a11y &&
        typeof window.theme.a11y.prefersReducedMotion === 'function' &&
        window.theme.a11y.prefersReducedMotion();

      // `fade` is intentionally omitted -> theme.Slideshow default fade:false -> a real
      // horizontal track. Slides-per-view comes from the cell CSS width, not from here.
      this.flickity = new window.theme.Slideshow(this.track, {
        cellAlign: 'left',
        groupCells: true,          // dots paginate by PAGE, matching the live site
        contain: true,
        wrapAround: false,
        pageDots: this.dataset.dots === 'true',
        prevNextButtons: this.dataset.arrows === 'true',
        adaptiveHeight: false,
        pauseAutoPlayOnHover: true,
        autoPlay: this.dataset.autoplay === 'true' && !reduced
          ? parseInt(this.dataset.autoplaySpeed, 10)
          : false
      });
    }

    disconnectedCallback() {
      if (this._onReady) document.removeEventListener('page:loaded', this._onReady);
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        try { this.flickity.destroy(); } catch (e) { /* editor teardown races are harmless */ }
      }
      this.flickity = null;
    }
  }

  customElements.define('lxb-lookbook-carousel', LxbLookbookCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
